"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TimeEvent = function TimeEvent(_ref) {
  var locale = _ref.locale,
      event = _ref.event,
      title = _ref.title;
  var difference = Math.abs(event.end - event.start) / 60000;
  var showStart = difference > 59 && difference < 24 * 60;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, showStart && !event.allDay && /*#__PURE__*/_react.default.createElement("div", {
    className: "event-start"
  }, event.start.toLocaleString(locale, {
    hour: 'numeric',
    minute: 'numeric',
    hour12: true
  })), title);
};

TimeEvent.propTypes = {
  title: _propTypes.default.string,
  event: _propTypes.default.shape({
    end: _propTypes.default.instanceOf(Date),
    start: _propTypes.default.instanceOf(Date),
    allDay: _propTypes.default.bool
  }),
  locale: _propTypes.default.string.isRequired
};
TimeEvent.defaultProps = {
  title: '',
  event: {}
};
var _default = TimeEvent;
exports.default = _default;